<div class="SideBorder">
	<!--Title-->
	<h4>Time Scan Mode Settings</h4>

	<div class="SelectGrid">
		<label>Time Scan Type:</label>
		<select class="form-control" name="ScanModeID" [(ngModel)]="SelectedTimeScanType">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstTimeScanType" [ngValue]="o">
				{{ o.TimeScanTypeDesc }}
			</option>
		</select>
	</div>

	<!--Buttons-->
	<div class="Buttons">
		<!--Original Button from Time Scan-->
		<button class="btn btn-primary" (click)="onSet()">Set</button>

		<button class="btn btn-primary SmallLeftMargin" (click)="onClose()">Close</button>
	</div>
</div>
